import React, { Component } from 'react';
import PropTypes from 'prop-types';

import declOfNum from '../../helpers/decl';

class AuthTimer extends Component {
  static propTypes = {
    count: PropTypes.number,
    words: PropTypes.arrayOf(PropTypes.string),
    callback: PropTypes.func,
  };

  componentDidMount() {
    const { callback } = this.props;
    const self = this;

    this.timer = setInterval(function() {
      const { count } = self.props;

      callback();

      if (count == 1) {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { count, words } = this.props;
    const word = declOfNum(count, words);

    return (
      <span className="time">{`\u00A0через\u00A0${count}\u00A0${word}`}</span>
    );
  }
}

export default AuthTimer;
